export { default } from './PdfTemplateFacts';
